import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class RazaoContabilService {

  readonly serviceApi = environment.apiUrl;

  constructor(private readonly http: HttpClient) { }

  requestRazaoContabil(idEmpresa: number, contaInicial: number, contaFinal: number, dataInicial: string, dataFinal: string) {
    return this.http.get(`${this.serviceApi}/v1/dominio-reports/razao-report?empresaId=${idEmpresa}&dataDe=${dataInicial}&dataPara=${dataFinal}&contaInicial=${contaInicial}&contaFinal=${contaFinal}`);

  }

}
